<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4" class="zh-card">
      <v-card class="elevation-12" :max-width="500">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>問卷調查系統</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              label="使用者名稱"
              v-model="userId"
              value="zhtech"
              prepend-icon="person"
              type="text"
            />
            <v-text-field
              v-model="password"
              label="密碼"
              value="24369238"
              prepend-icon="lock"
              type="password"
            />
          </v-form>
          <v-btn color="primary" block @click="doLogin()">登入</v-btn>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      userId: '',
      password: ''
    }
  },
  methods: {
    async doLogin(type) {
      // 以 api/Adimin/Login 登入
      let url = this.$store.state.api + '/Admin/Login'
      // let url =  '/admin/api/Admin/Login'
      let data = { userId: this.userId, password: this.password }
      try {
        let res = await this.axios.post(url, this.qs.stringify(data))
        if (res.data.resultCode === '10') {
          // 登入成功
          window.console.log('登入成功')
          this.$router.push({ name: 'Admin' })
        } else {
          // 登入失敗
          window.console.log('登入失敗')
          alert('登入失敗')
        }
      } catch (err) {
        alert(window.console.error(err.toString()))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zh-card {
  opacity: 0.75;
}
</style>
